var AppComponent = (function () {
    function AppComponent() {
        this.title = 'app';
    }
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/app.component.ts.pre-build-optimizer.js